import { render, staticRenderFns } from "./SubMenuItem.vue?vue&type=template&id=3ff25a9c&scoped=true&"
import script from "./SubMenuItem.vue?vue&type=script&lang=js&"
export * from "./SubMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SubMenuItem.vue?vue&type=style&index=0&id=3ff25a9c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff25a9c",
  null
  
)

export default component.exports